import { gql } from '@apollo/client'
export const getAnnouncementsQuery = gql`
  query Announcements($getAnnouncementParams: GetAnnouncementParams!) {
    announcements(getAnnouncementParams: $getAnnouncementParams) {
      RegionId
      announcement_id
      body
      date
      filter_grades
      filter_users
      filter_others
      filter_providers
      filter_program_years
      filter_school_partners
      filter_application_statuses
      posted_by
      schedule_time
      status
      subject
      isArchived
    }
  }
`

export const CreateAnnouncementMutation = gql`
  mutation CreateAnnouncement($createAnnouncementInput: CreateAnnouncementInput!) {
    createAnnouncement(createAnnouncementInput: $createAnnouncementInput) {
      announcement_id
      date
      filter_grades
      filter_users
      filter_providers
      filter_program_years
      filter_school_partners
      filter_application_statuses
      status
      subject
      posted_by
    }
  }
`

export const UpdateAnnouncementMutation = gql`
  mutation UpdateAnnouncement($updateAnnouncementInput: UpdateAnnouncementInput!) {
    updateAnnouncement(updateAnnouncementInput: $updateAnnouncementInput) {
      announcement_id
      date
      filter_grades
      filter_users
      filter_providers
      filter_program_years
      filter_school_partners
      filter_application_statuses
      status
      subject
      posted_by
    }
  }
`

export const GetCurrentSchoolYearByRegionId = gql`
  query Schoolyear_getcurrent($regionId: Int!) {
    schoolyear_getcurrent(region_id: $regionId) {
      school_year_id
      grades
      RegionId
      date_begin
      date_end
      enrollment_packet
      midyear_application
      midyear_application_open
      midyear_application_close
      schoolEnrollmentYear {
        id
        active
        school_year_id
        school_of_enrollment_id
        schoolPartner {
          name
          abbreviation
          region_id
        }
      }
      SchoolPartners {
        abbreviation
        name
        id
      }
      ScheduleBuilder {
        id
        max_num_periods
        custom_built
        split_enrollment
        always_unlock
        parent_tooltip
        school_year_id
      }
      schedule
      diploma_seeking
      testing_preference
      special_ed
      special_ed_options
      participation_tracking
      participation_option
    }
  }
`

export const GetNextSchoolYearByRegionId = gql`
  query SchoolYear_getNext($regionId: Int!) {
    nextSchoolYear(region_id: $regionId) {
      school_year_id
      grades
      RegionId
      date_begin
      date_end
      enrollment_packet
      midyear_application
      midyear_application_open
      midyear_application_close
      schoolEnrollmentYear {
        id
        active
        schoolPartner {
          name
        }
      }
      ScheduleBuilder {
        id
        max_num_periods
        custom_built
        split_enrollment
        always_unlock
        parent_tooltip
        school_year_id
      }
      schedule
      diploma_seeking
      testing_preference
      special_ed
      special_ed_options
    }
  }
`

export const deleteAnnouncementsById = gql`
  mutation deleteAnnouncementsById($id: Int!) {
    deleteAnnouncementsById(id: $id) {
      error
      message
    }
  }
`

export const ToggleArchiveAnnouncementMutation = gql`
  mutation archiveAnnouncement($announcement_id: Int!) {
    archiveAnnouncement(announcement_id: $announcement_id) {
      announcement_id
      date
      filter_grades
      filter_users
      filter_providers
      filter_program_years
      filter_school_partners
      status
      subject
      posted_by
    }
  }
`
